import {IncrementDecrementType} from "../types/IncrementDecrementType";

export const decrement = ({ref}: IncrementDecrementType) => {
  if (ref.current){
    const currentValue = parseInt(ref.current.value, 10);
    const value = currentValue - 1 >= 0 ? currentValue - 1 : 0
    ref.current.value = `${value}`;
    return  `${value}`
  }
  return '1'
}
